import { isNil } from 'lodash'
import { EditTariffFormModelDto, PriceComponentDto } from '../api/dto/tariffs-form.dto'
import { EditTariffFormData } from '../models/tariffs-form-model'

const STEP_SIZE_VALUE = 1

/**
 * Function for transforming tariffs from model to be dto form model for edit tariff
 * @param tariffs - EditTariffFormData object
 * @param installationId - unique installation identifier as number
 * @returns object of TariffFormModelDto
 */
export const editTariffsFormToDto = (data: EditTariffFormData, installationId: number): EditTariffFormModelDto => {
  const gridPriceComponent: PriceComponentDto = { price: Number(data.tariffGridPrice), type: 'ENERGY', step_size: STEP_SIZE_VALUE }
  const solarPriceComponent: PriceComponentDto = { price: Number(data.tariffSolarPrice), type: 'FLAT', step_size: STEP_SIZE_VALUE }

  return {
    tariffId: data.tariffId,
    installationId,
    tariffName: data.tariffName,
    dischargePrice: isNil(data.tariffDischargePrice) ? undefined : Number(data.tariffDischargePrice),
    tariffDto: {
      start_date_time: data.startDate && new Date(data.startDate).toISOString(),
      end_date_time: data.endDate && new Date(data.endDate).toISOString(),
      elements: [
        {
          price_components: [gridPriceComponent, ...(isNil(data.tariffSolarPrice) ? [] : [solarPriceComponent])],
        },
      ],
    },
  }
}
